import React from "react";
import PropTypes from "prop-types";
import Styled from "styled-components";
import { MdChevronLeft as ChevronLeftIcon } from "react-icons/md";
import { MdChevronRight as ChevronRightIcon } from "react-icons/md";

const List = Styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 8px 0;
`;

const ListItem = Styled.div`
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 5px;
  position: relative;
  font-size: 1.2rem;
  color: rgba(${props => props.theme.primaryText}, 0.5);
  text-align: center;
  &:hover, &.selected {
      color: ${props => props.theme.textOnPrimary};
      background: ${props => props.theme.computedPrimary};
  }
`;

const Paginator = props => {
  const pages = [];
  for (let page = 1; page <= props.numOfPages; page += 1) {
    pages.push(page);
  }
  return (
    <List>
      <ListItem onClick={() => props.onPageChange(props.currentPage - 1)}>
        <ChevronLeftIcon style={{ fontSize: "1.8rem" }} />
      </ListItem>
      {pages.map(page => {
        const distance = Math.abs(props.currentPage - page);
        if (
          distance <= 5 ||
          (page >= props.currentPage && page <= 11) ||
          (page <= props.currentPage && page >= pages.length - 11)
        )
          return (
            <ListItem
              className={props.currentPage === page ? "selected" : ""}
              key={page}
              onClick={() => props.onPageChange(page)}
            >
              {page}
            </ListItem>
          );
        return null;
      })}
      <ListItem onClick={() => props.onPageChange(props.currentPage + 1)}>
        <ChevronRightIcon style={{ fontSize: "1.8rem" }} />
      </ListItem>
    </List>
  );
};

Paginator.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  numOfPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired
};

Paginator.defaultProps = {};

export default Paginator;
